import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import $ from 'jquery';
import { TimePicker } from "antd";
import moment from "moment";
import Toastr from 'toastr';
import SessionManager from "../../routes/SessionManager";
import Loading from "../Loading";
import bootbox from 'bootbox';
import CommonUtils from "../../util/CommonUtils";
import ShareVideoEmailTemplate from '../../views/email-templates/share-video-template';

import { Pagination } from 'antd';

const ZoneHistoricalVideo = (props) => {

    let timezone = props.timezone;
    let user = new SessionManager().readCookie('user');
    let recordings = props.recording;
    let is_axis_camera = user.zone_selected.location_device_type && user.zone_selected.location_device_type === 'axis';
    let max_video_interval = 10 * 60;
    let loading_message = 'Fetching videos ...';
    const [current, setCurrent] = useState(1);

    // console.log('timestamp range: ', timestampRange);
    // if (isRecordingAvailable) {
    // let start_time = [moment.tz(this.timestampRange[0] * 1000, this.timezone).format('YYYY-MM-DD HH:mm'), moment.tz(this.timestampRange[1] * 1000, this.timezone).format('YYYY-MM-DD HH:mm')]
    // let hhmm = [parseInt(start_time[0].substring(11, 13)), parseInt(start_time[0].substring(14, 16)), parseInt(start_time[1].substring(11, 13)), parseInt(start_time[1].substring(14, 16))]
    // for (let i = 0; i < 24; i++) {
    //     if (i < hhmm[0])
    //         this.disabledTime[0].push(i);

    //     if (i > hhmm[2])
    //         this.disabledTime[2].push(i);
    // }
    //     console.log('Allowed Range: ' + [moment.tz(this.timestampRange[0] * 1000, this.timezone).format('YYYY-MM-DD HH:mm'), moment.tz(this.timestampRange[1] * 1000, this.timezone).format('YYYY-MM-DD HH:mm')]);
    // }
    // this.ts_step = (this.timestampRange[1] - this.timestampRange[0]) / 100;
    // this.max_video_generated_ts = 0;

    let locationLastState = !is_axis_camera && JSON.parse(user.zone_selected.location_last_state);
    let last_usb_available_hour = locationLastState && locationLastState.last_usb_available_hour;

    const [timestampRange, setTimestampRange] = useState(props.timestampRange);
    const [timestampRangeNew, setTimestampRangeNew] = useState([...timestampRange]);
    const [historyRec, setHistoryRec] = useState(props.historyRec);
    const [video, setVideo] = useState(null);
    const [videos, setVideos] = useState(null);
    const [video_url, setVideoUrl] = useState(null);
    const [isRecordingAvailable, setIsRecordingAvailable] = useState(true);
    const [recording_capable, setRecordingCapable] = useState(true);
    const [generated_video, setGeneratedVideo] = useState(false);
    const [disabledTime, setDisabledTime] = useState([[], [], [], []]);
    const [max_video_generated_ts, setMaxVideoGeneratedTs] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (is_axis_camera) {
            let axis_time = getTimestampRange();
            setTimestampRange(axis_time);
            setTimestampRangeNew([...axis_time]);
        } else {
            setTimestampRange(props.timestampRange);
            setTimestampRangeNew(props.timestampRange);
        }
        setGeneratedVideo(false);
        setHistoryRec([0, 100]);
        setVideoUrl(null);
        setVideo(null);
        setMaxVideoGeneratedTs(0);
        fetchVideos(0);
    }, [props]);

    function getTimestampRange() {
        setIsRecordingAvailable(false);
        let today = moment(new Date()).utc();
        let todaySite = today.clone().tz(timezone).format("YYYY-MM-DD HH:mm:ss");
        let today_date = todaySite.substring(0, 10);
        let image_date = moment.tz(props.timestampRange[0] * 1000, timezone).format('YYYY-MM-DD');
        // this.image_date = image_date;

        console.log('this.recordings', recordings);

        if (!recordings || recordings.length === 0)
            return [];

        for (let r of recordings) {
            console.log(r.attributes['starttime'] + '  --  ' + r.attributes['stoptime']);
        }

        console.log('|' + image_date + ' ' + (today_date === image_date ? todaySite.substring(11) : '23:59:59') + '|')

        let max_window = [
            moment.tz(image_date + ' 00:00:00', "YYYY-MM-DD HH:mm:ss", timezone).utc().format("YYYY-MM-DDTHH:mm:ss.000000[Z]"),
            moment.tz(image_date + ' ' + (today_date === image_date ? todaySite.substring(11) : '23:59:59'), "YYYY-MM-DD HH:mm:ss", timezone).utc().format("YYYY-MM-DDTHH:mm:ss.999999[Z]")
        ];
        console.log('timezone in utc', max_window);

        let actual_window = [...max_window];
        let timeset = [false, false];
        let processed = [false, false]

        for (let r of recordings) {
            let rWindow = [r.attributes['starttime'], r.attributes['stoptime']];
            console.log('rWindow', rWindow);
            if (!timeset[0]) {
                if (rWindow[0] <= actual_window[0]) {
                    if (rWindow[1] === '' || (rWindow[1] > actual_window[0])) {
                        processed[0] = true;
                        actual_window[0] = max_window[0];

                        if (actual_window[0] <= max_window[0])
                            timeset[0] = true;

                        console.log('new start time ' + actual_window[0] + ' is set ?' + timeset[0]);
                    } else
                        continue;
                } else {
                    if ((rWindow[1] === '' || rWindow[1] > actual_window[0]) && rWindow[0] < actual_window[1]) {
                        actual_window[0] = rWindow[0];
                        processed[0] = true;
                        console.log('new start time ' + actual_window[0] + ' is set ?' + timeset[0]);
                    } else
                        continue;
                }
            }

            if (!timeset[1]) {
                if (rWindow[1] === '' || rWindow[1] >= actual_window[1]) {
                    if (rWindow[0] <= max_window[1]) {
                        actual_window[1] = (rWindow[1] === '' || rWindow[1] >= max_window[1]) ? max_window[1] : rWindow[1];
                        processed[1] = true;
                        if (actual_window[1] >= max_window[1])
                            timeset[1] = true;

                        console.log('new stop time ' + actual_window[1] + ' is set ?' + timeset[1]);
                    } else
                        continue;
                } else {
                    if (rWindow[1] > actual_window[0]) {
                        processed[1] = true;
                        actual_window[1] = rWindow[1];
                        console.log('new stop time ' + actual_window[1] + ' is set ?' + timeset[1]);
                    } else
                        continue;
                }
            }

        }

        let start_time = moment.tz(new Date(actual_window[0]).getTime(), timezone).format('YYYY-MM-DD HH:mm');
        let end_time = moment.tz(new Date(actual_window[1]).getTime(), timezone).format('YYYY-MM-DD HH:mm');

        setDisabledTime([[], [], [], []]);
        let hhmm = [parseInt(start_time.substring(11, 13)), parseInt(start_time.substring(14, 16)), parseInt(end_time.substring(11, 13)), parseInt(end_time.substring(14, 16))]
        for (let i = 0; i < 24; i++) {
            if (i < hhmm[0])
                disabledTime[0].push(i);

            if (i > hhmm[2])
                disabledTime[2].push(i);
        }

        // for (let i = 0; i <= 59; i++) {
        //     if (i < hhmm[1])
        //         this.disabledTime[1].push(i);

        //     if (i > hhmm[3])
        //         this.disabledTime[3].push(i);
        // }

        let isRecordingAvailable = processed.indexOf(false) === -1
        setIsRecordingAvailable(isRecordingAvailable);
        if (isRecordingAvailable) {
            if ((image_date === today_date) && today.clone().tz(timezone).diff(moment.tz(new Date(actual_window[0]).getTime(), timezone), 'minute') < (max_video_interval / 60)) {
                setIsRecordingAvailable(false);
                setRecordingCapable(false);
            }
        }

        return [new Date(actual_window[0]).getTime() / 1000, new Date(actual_window[1]).getTime() / 1000, isRecordingAvailable,];

        // this.isRecordingAvailable = this.recordings != null && (dateRange[1].substring(0, 10) <= this.image_date);
        // let utc_times = [];
        // let start_utc = 0;
        // if (this.recording && dateRange[1].substring(0, 10) === image_date) {
        //     let recordingAvailableDate = this.recording['starttime'];
        //     start_utc = (new Date(recordingAvailableDate).getTime() / 1000 + 3600); // Added an hour so that we don't miss start of the recording
        // } else {
        //     start_utc = DateUtil.getDbData(this.timezone, image_date);
        // }
        // utc_times.push(start_utc);

        // if (today_date !== image_date) {
        //     utc_times.push(DateUtil.getDbData(this.timezone, image_date) + (24 * 60 * 60 - 1));
        // } else {
        //     let endDateTimeM = moment(new Date());
        //     let end_date_time = endDateTimeM.clone().tz(this.timezone).format("YYYY-MM-DD HH:mm");
        //     let userTimeNowDB = DateUtil.getDbData(this.timezone, end_date_time);
        //     utc_times.push(userTimeNowDB);
        // }


        // //console.log(moment.tz(utc_times[0] * 1000, this.timezone).format('YYYY-MM-DD HH:mm'))
        // //console.log(moment.tz(utc_times[1] * 1000, this.timezone).format('YYYY-MM-DD HH:mm'))
        // return [utc_times[0], utc_times[1]];
    }

    let manageCameraFeed = async (operation, extraAtts = {}) => {
        return new Promise(async function (resolve, reject) {
            let device_iotname = null;
            if (props.zone.location_device_type === 'uniview') {
                let deviceObj = await CommonUtils.getDevice(props.zone.device_id, user);
                device_iotname = deviceObj ? deviceObj.device_iotname : null;
            }

            var data = {
                user_login: user.user_login,
                user_token: user.user_token,
                form_input: { operation: operation, device_id: props.zone.device_id, device_iotname: device_iotname, device_type: props.zone.location_device_type, ...extraAtts }
            };

            $.ajax(
                {
                    url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/live-camera-feed',
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    data: JSON.stringify(data)
                }
            ).then(
                (res) => {
                    if (res.status) {
                        if (res.status.code === 200)
                            resolve(res.data);
                        else
                            reject(null);
                    } else {
                        reject(null);
                    }
                },
                (error) => {
                    reject(null);
                }
            );
        }).catch((err) => { });
    }

    let generateVideo = async () => {
        if (is_axis_camera) {
            return generateAxisVideo();
        }

        if (timestampRangeNew[0] === timestampRangeNew[1]) {
            Toastr.error('Start and End timestamps should be different to generate a video.');
            return;
        }
        setLoading(true);
        setVideo([]);
        setVideoUrl(null);
        setVideo(null);

        let extraAtts = {
            customer_id: props.zone.customer_id,
            location_id: props.zone.location_id,
            site_id: props.zone.site_id,
            start_ts: timestampRangeNew[0],
            end_ts: timestampRangeNew[1],
            image_ts: historyRec.sec_timestamp,
            use_all_images: (timestampRangeNew[1] - timestampRangeNew[0]) <= 180  //use all images in given duration.
        };
        console.log('Applying Range: ' + [moment.tz(extraAtts.start_ts * 1000, timezone).format('YYYY-MM-DD HH:mm'), moment.tz(extraAtts.end_ts * 1000, timezone).format('YYYY-MM-DD HH:mm')])
        let result = await manageCameraFeed('save-historic-clip', extraAtts);
        //console.log('result', result);
        if (result) {
            Toastr.success('Video request submitted successfully!');
            setLoading(false);
            setGeneratedVideo(true);
            fetchVideos(100, true);//callback
        } else {
            setLoading(false);
            Toastr.error('Unable to generate video for given date range.', 'Status');
        }
    }

    let confirmMaxLengthVideo = () => {
        return new Promise((resolve, reject) =>
            bootbox.dialog({
                message: "Would you like to generate full length video ? ",
                buttons: [
                    { callback: () => resolve(false), label: 'No, default duration please ...' },
                    { callback: () => resolve(true), label: 'Yes' }
                ]
            })
        );
    }

    let generateAxisVideo = async () => {
        if (timestampRangeNew[0] === timestampRangeNew[1]) {
            Toastr.error('Start and End timestamps should be different to generate a video.');
            return;
        }

        let range = [timestampRangeNew[0], timestampRangeNew[1]];
        if (videos) {
            let video = videos.filter(v => v.video_orig_ref.split('.')[0].split('_')[2] === String(range[0]));
            if (video.length > 0) {
                Toastr.error("Video already exists at this start timestamp.");
                return
            }
        }

        let isGreaterRange = (range[1] - range[0]) > max_video_interval;
        let confirmMaxVideoGenGiven = false;

        if (isGreaterRange) {
            let isMaxLengthVideoAllowed = CommonUtils.hasPermission('SITESUPT-UI-GENERATE-MAX-LEN-VIDEO');
            if (isMaxLengthVideoAllowed) // take confirmation if allowed.
                confirmMaxVideoGenGiven = await confirmMaxLengthVideo();
        }

        if (!confirmMaxVideoGenGiven && isGreaterRange) {
            //range[1] = range[0] + max_video_interval;
            Toastr.info("Duration has been reduced to " + (max_video_interval / 60) + " mins for video generation.");
        }

        //console.log(moment.tz(range[0] * 1000, this.timezone).format('YYYY-MM-DD HH:mm'));
        //console.log(moment.tz(range[1] * 1000, this.timezone).format('YYYY-MM-DD HH:mm'));

        let timestamp_to_tag = range[0];
        let prev = range[0];
        for (let t of props.timestamps.sort()) {
            if (t >= range[0]) {
                timestamp_to_tag = t > range[1] ? prev : t;
                break;
            }
            prev = t;
        }

        let recordingsReq = {
            starttime: (moment.tz(range[0] * 1000, timezone).utc().format('YYYY-MM-DDTHH:mm:ss.000000[Z]')), //2023-03-05T09:45:09Z
            stoptime: (moment.tz(range[1] * 1000, timezone).utc().format('YYYY-MM-DDTHH:mm:ss.999999[Z]')),
        };

        let recordingsFound = getRecordingInfos(recordingsReq);

        // for (let rFound of recordingsFound) {
        //     let data = {
        //         device_id: props.zone.device_id,
        //         recordingid: rFound.recordingid,
        //         customer_id: props.zone.customer_id,
        //         location_id: props.zone.location_id,
        //         site_id: props.zone.site_id,
        //         start_ts: moment.tz(moment(rFound._starttime), timezone).format('YYYY-MM-DDTHH:mm:ss'), //2023-03-05T09:45:09Z
        //         end_ts: moment.tz(moment(rFound._stoptime), timezone).format('YYYY-MM-DDTHH:mm:ss'),
        //         sec_timestamp: range[0],
        //         sec_timestamp_end: (range[1] - range[0]),
        //         user_login: user.user_login,
        //         user_token: user.user_token,
        //         timestamp: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
        //         timestamp_to_tag: timestamp_to_tag,
        //         vid_duration_max_allowed: confirmMaxVideoGenGiven ? (range[1] - range[0]) : 0
        //     }
        //     generateAxisVideos(data);
        // }

        if (!recordingsFound) {
            setLoading(false);
            Toastr.success('No recording found during the interval selected !');
            return;
        }

        let data = {
            device_id: props.zone.device_id,
            //recordingid: recordingsFound[0].recordingid,
            customer_id: props.zone.customer_id,
            location_id: props.zone.location_id,
            site_id: props.zone.site_id,
            start_ts: recordingsReq.starttime, //2023-03-05T09:45:09Z
            end_ts: recordingsReq.stoptime,
            sec_timestamp: range[0],
            sec_timestamp_end: parseInt(range[1] - range[0]),
            user_login: user.user_login,
            user_token: user.user_token,
            timestamp: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
            timestamp_to_tag: timestamp_to_tag,
            vid_duration_max_allowed: confirmMaxVideoGenGiven ? (range[1] - range[0]) : 0
        }
        generateAxisVideos(data);
    }

    let generateAxisVideos = (extraAtts) => {
        $.ajax(
            {
                url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/axis-camera/save-video",
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                headers: {
                    user_login: user.user_login,
                    user_token: user.user_token
                },
                data: JSON.stringify(extraAtts)
            }
        ).then(
            (res) => {
                if (res.status) {
                    if (res.status.code === 200) {
                        Toastr.success("Video request submitted successfully");
                        setLoading(false);
                        setGeneratedVideo(true);
                        fetchVideos(100, true);
                    }
                    else
                        Toastr.success("Error while submitting request");
                } else {
                    Toastr.success("Error while submitting request");
                }
            },
            (error) => {
                Toastr.success("Error while submitting request");
            }
        );
    }

    let getRecordingInfos = (time_range) => {

        console.log('time_range', time_range);
        let recording = { ...time_range };
        let recording_info = [];

        for (let r of recordings) {

            if (r.attributes.starttime < recording.starttime && (r.attributes.stoptime === '' || r.attributes.stoptime >= recording.starttime)) {
                if (r.attributes.stoptime !== '' && r.attributes.stoptime <= recording.stoptime) {
                    recording.stoptime = r.attributes.stoptime;
                    recording_info.push({ ...r.attributes, _starttime: recording.starttime, _stoptime: recording.stoptime });

                    recording.starttime = r.attributes.stoptime;
                    recording.stoptime = time_range.stoptime;
                } else {
                    recording_info.push({ ...r.attributes, _starttime: recording.starttime, _stoptime: recording.stoptime });
                    break;
                }

            } else if (r.attributes.starttime >= recording.starttime && (r.attributes.stoptime === '' || r.attributes.starttime <= recording.stoptime)) {
                recording.starttime = r.attributes.starttime;

                if (r.attributes.stoptime !== '') {
                    if (r.attributes.stoptime <= recording.stoptime) {
                        recording.stoptime = r.attributes.stoptime;
                        recording_info.push({ ...r.attributes, _starttime: recording.starttime, _stoptime: recording.stoptime });

                        recording.starttime = r.attributes.stoptime;
                        recording.stoptime = time_range.stoptime;
                    } else {
                        recording_info.push({ ...r.attributes, _starttime: recording.starttime, _stoptime: recording.stoptime });
                        break;
                    }
                } else {
                    if (recording.stoptime > r.attributes.starttime)
                        recording_info.push({ ...r.attributes, _starttime: recording.starttime, _stoptime: recording.stoptime });
                    break;
                }
            }
        }
        console.log('recording_info', recording_info);
        return recording_info;
    }

    let fetchVideos = async (attempts = 100, isVideoGen = false) => {
        console.log('attempts', attempts);
        setLoading(true);
        if (props.zone === undefined)
            return;

        let extraAtts = {
            customer_id: props.zone.customer_id,
            location_id: props.zone.location_id,
            site_id: props.zone.site_id,
            start_ts: props.timestamps[0],
            end_ts: props.timestamps[props.timestamps.length - 1]
        };
        let result = await manageCameraFeed('get-historic-clip', extraAtts);
        if (result && result.videos && result.videos.length > 0) {
            let curr_max_video_generated_ts = max_video_generated_ts;
            for (let v of result.videos)
                if (v.timestamp > curr_max_video_generated_ts + "")
                    curr_max_video_generated_ts = v.timestamp;

            if (max_video_generated_ts !== 0) {
                if (curr_max_video_generated_ts > max_video_generated_ts) {
                    setMaxVideoGeneratedTs(curr_max_video_generated_ts);
                    setLoading(false);
                    setVideos(result.videos);
                    setVideoUrl(result.videos[0].video_url);
                    setVideo(result.videos[0]);

                } else {
                    if (attempts > 0 && Object.keys(props).length !== 0)
                        setTimeout(() => { fetchVideos(--attempts, isVideoGen); }, 20000);
                    else {
                        setLoading(false);
                        if (isVideoGen) {
                            setMaxVideoGeneratedTs(0);
                            fetchVideos(0);
                        }
                    }
                }
            } else {
                setMaxVideoGeneratedTs(curr_max_video_generated_ts);
                setLoading(false);
                setVideos(result.videos);
                setVideoUrl(result.videos[0].video_url);
                setVideo(result.videos[0]);
            }

            console.log('this.max_video_generated_ts', max_video_generated_ts);
        } else {
            if (attempts > 0 && Object.keys(props).length !== 0)
                setTimeout(() => { fetchVideos(--attempts, isVideoGen); }, 20000);
            else {
                setLoading(false);
                if (isVideoGen) {
                    setMaxVideoGeneratedTs(0);
                    fetchVideos(0);
                }
            }
        }
    }

    let onSliderChange = (...args) => {
        if (args[0] != null && args[0].length > 0) {
            setTimestampRangeNew([args[0][0].unix(), args[0][1].unix()]);
        }
    }

    let handleModalClose = () => {
        props.closeModal();
        let pageRefresh = props.refreshZoneHistory;
        if (generated_video)
            setTimeout(() => { pageRefresh() }, 2000);
        props = {};
    }

    let loadVideo = (v) => {
        setVideoUrl(v.video_url);
        setVideo(v);
    }

    let shareVideo = () => {
        bootbox.prompt({
            closeButton: false,
            inputType: 'textarea',
            title: 'Share Video',
            message: 'Please enter semicolon(;) separated email ids to share video', callback: (email_ids) => {
                if (email_ids) {
                    let email_validation = CommonUtils.validateCommaSeparatedEmails(email_ids);

                    if (email_validation.found === 0) {
                        Toastr.error("No email ids found to share the video.");
                        return false;
                    }

                    if (email_validation.valid.length === 0 || email_validation.invalid.length > 0) {
                        Toastr.error("Invalid Email Addresses found. <br />Please correct and try again ! <br />" + email_validation.invalid.join('<br />'));
                        return false;
                    }

                    let v = video;
                    let container = document.createElement('div');
                    ReactDOM.render(
                        <ShareVideoEmailTemplate
                            location_name={user.zone_selected.location_name}
                            timestamp={moment.tz(v.sec_timestamp * 1000, timezone).format('MMM DD, YYYY HH:mm')}
                            video_url={v.video_url}
                            user_name={user.user_name}>
                        </ShareVideoEmailTemplate>, container);

                    let video_parts = v.video_orig_ref.split('.')[0].split('_');
                    let video_duration = video_parts.length === 4 ? parseInt(video_parts[3]) : 0;
                    CommonUtils.sendEmail({
                        // user_login: _this.user.user_login,
                        // user_token: _this.user.user_token,
                        // form_input: {
                        //     operation: 'send-email',
                        //     recipients: email_validation.valid,
                        //     subject: "Recorded Live Video - " + moment.tz(v.sec_timestamp * 1000, _this.timezone).format('MMM DD, YYYY HH:mm'),
                        //     email_body: $(container).html()
                        // }

                        user_login: user.user_login,
                        user_token: user.user_token,
                        site_id: user.site_selected.site_id,
                        location_id: user.zone_selected.location_id,
                        video_url: v.video_url,
                        end_time: v.sec_timestamp + video_duration,
                        start_time: v.sec_timestamp,
                        share_email: email_validation.valid.join(';'),
                        video_type: 'video_clip'  //'Recorded Live Video'

                        // form_input: {
                        //     operation: 'send-email',
                        //     recipients: email_validation.valid,
                        //     subject: "Recorded Live Video - " + moment.tz(v.sec_timestamp * 1000, _this.timezone).format('MMM DD, YYYY HH:mm'),
                        //     email_body: $(container).html()
                        // }
                    }).then((result) => {
                        Toastr.success("Video shared successfully !!");
                    }, (error) => {
                        Toastr.success("Failed to share the video. Please try again ...");
                        return false;
                    });
                }
            }
        });
    }

    const onHistoricVideoChange = (page, pageSize) => {
        setCurrent(page);
    }

    const getVideosForCurrentPage = () => {
        let idx = (current - 1) * 5;
        return videos && videos.filter((v, i) => (i >= idx && i < (idx + 5)));
    }

    let isHistoricalAvailable = last_usb_available_hour && (parseInt(moment.tz(last_usb_available_hour, timezone).format("X")) > parseInt(timestampRangeNew[1]) && parseInt(moment.tz(last_usb_available_hour, timezone).format("X")) > parseInt(timestampRangeNew[0]));
    console.log(timestampRangeNew[1], timestampRangeNew[0]);
    return (
        <React.Fragment>
            <div className="modal-header p-2 bg-primary text-white">
                Historical Video - {user.zone_selected.location_name} - {moment.tz(timestampRangeNew[0] * 1000, timezone).format('MMM DD, YYYY')}
                <button type='button' className='far fa-lg fa-times-circle pull-right' data-dismiss='modal' onClick={handleModalClose}></button>
            </div>
            <div className="modal-body p-0 m-0 border-rounded-b">
                <div className="container">
                    {!loading ?
                        isRecordingAvailable ? <React.Fragment>
                            <div className="row py-1">
                                <div className="col-md-9 pt-1">
                                    Time Range :
                                    <TimePicker.RangePicker allowClear={false} inputReadOnly='readonly' disabledTime={(...args) => { return { disabledHours: () => disabledTime[args[1] === 'start' ? 2 : 2], disabledMinutes: () => disabledTime[args[1] === 'start' ? 1 : 3] } }} defaultValue={[moment.tz(timestampRangeNew[0] * 1000, timezone), moment.tz(timestampRangeNew[1] * 1000, timezone)]} onChange={onSliderChange} format={'HH:mm'} />
                                </div>
                                <div className="col-md-3 text-right pt-1">
                                    {!loading &&
                                        <button className="btn btn-sm btn-primary" disabled={(user.zone_selected.location_operstatus === "Disconnected" || (!is_axis_camera && isHistoricalAvailable === true)) ? true : false} onClick={generateVideo}>Generate Historical Video</button>
                                    }
                                </div>
                            </div>
                            {isHistoricalAvailable && !is_axis_camera &&
                                <div className="row">
                                    <span className="col-md-12 text-right">
                                        <i className="fa fa-exclamation-triangle" style={{ color: "orange" }}></i>
                                        {` Videos can be generated from ${last_usb_available_hour} `}
                                    </span>
                                </div>
                            }
                        </React.Fragment>
                            :
                            <div className="row">
                                <div className="col-md-12 p-2">{recording_capable ? "No historical video information found." : "No storage disk found to generate the video."}</div>
                            </div>
                        :
                        <div className="row">
                            <div className="col-md-12 text-center my-4">
                                <Loading>{loading_message}</Loading><br />
                                <div className="mt-2 font-size-12">Note: Video generation is in progress and might take a while. So, you can close this dialog window and visit after 10 minutes.
                                </div>
                            </div>
                        </div>
                    }
                    {video_url &&
                        <div className="row bg-light border-rounded-b p-2">
                            <div className="col-10 p-0">
                                <button style={{ position: "absolute", right: '5px', top: '5px', zIndex: 3000 }} className="btn btn-sm btn-primary"><i className="fa fa-share" onClick={() => shareVideo()}></i></button>
                                <video className="border-rounded" width="100%" style={{ objectFit: 'cover' }} controls id="video_url" src={video_url} />
                                {!is_axis_camera && <span><b>Note:</b> Images will be spaced out for longer duration. </span>}
                            </div>
                            <div className="col-2 pl-2 p-0">
                                <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                                    {videos && videos.length && <Pagination simple current={current} pageSize={5} onChange={onHistoricVideoChange} total={videos.length} />}
                                    {
                                        getVideosForCurrentPage().map((v, i) => {
                                            let video_file_name = v.video_url ? v.video_url.split('?')[0] : '';
                                            let video_url_parts = video_file_name.split('/');
                                            let video_parts = video_url_parts && video_url_parts.length > 0 ? video_url_parts[video_url_parts.length - 1].split('.')[0].split('_') : [];
                                            console.log('video_parts', [video_file_name, video_parts])
                                            return <div className="row py-1" key={'video_' + i}>
                                                <div className="col-12">
                                                    <div className="card cursor-pointer">
                                                        <div className="card-body p-0 border-rounded-0">
                                                            <video className="border-rounded-t" style={{ objectFit: 'cover' }} onClick={() => loadVideo(v)} width="100%" id="video_url" src={v.video_url} />
                                                        </div>
                                                        <div className="card-footer p-1 bg-primary text-white font-size-12">
                                                            {moment.tz((!isNaN(video_parts[2]) ? video_parts[2] : v.sec_timestamp) * 1000, timezone).format('HH:mm:ss')}
                                                            {video_parts.length === 4 && !isNaN(video_parts[2]) && !isNaN(video_parts[3]) ? ' - ' + moment.tz(1000 * (parseInt(video_parts[2]) + parseInt(video_parts[3])), timezone).format('HH:mm:ss') : ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </React.Fragment>
    );
}

export default ZoneHistoricalVideo;